import { Amplify } from 'aws-amplify';
// Configure Amplify against the internal/staff Cognito pool. The pool id and
// web client id are injected at build time by dotenv-webpack (.env.dev /
// .env.prod), mirroring the chargeback dashboard frontend.
export const configureAmplify = () => {
    const userPoolId = process.env.COGNITO_USER_POOL_ID;
    const userPoolClientId = process.env.COGNITO_WEB_CLIENT_ID;
    if (!userPoolId || !userPoolClientId) {
        throw new Error('COGNITO_USER_POOL_ID and COGNITO_WEB_CLIENT_ID must be configured');
    }
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId,
                userPoolClientId
            }
        }
    });
};
